import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../services/firebase";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Switch from "@mui/material/Switch";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
// import { useNavigate } from "react-router-dom";
import { investmentService } from "../investments/investmentService";
import { opportunitiesService } from "../opportunities/opportunitiesService";
// TODO(api): Replace direct getUserActivity import with API call
// import { getUserActivity } from '../services/reportingService';
import { Typography } from "@mui/material";
import ComplianceSecuritySection from "../components/ComplianceSecuritySection";
import { useUserComplianceData } from "../hooks/useUserComplianceData";
// import {
//     Grid
// } from "@mui/material";
import {
// Edit as EditIcon,
// Save as SaveIcon,
// Cancel as CancelIcon,
// Security as SecurityIcon,
// Notifications as NotificationsIcon,
// Language as LanguageIcon,
// AccountCircle as AccountCircleIcon,
// Email as EmailIcon,
// Phone as PhoneIcon,
// LocationOn as LocationOnIcon,
// Business as BusinessIcon,
// VerifiedUser as VerifiedUserIcon,
// Warning as WarningIcon,
// CheckCircle as CheckCircleIcon,
// Error as ErrorIcon,
// Info as InfoIcon
} from "@mui/icons-material";

const Profile = ({ darkMode, setDarkMode }) => {
    const { userProfile, kycData, currentUser } = useAuth();
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [consent, setConsent] = useState(false);
    // const [language, setLanguage] = useState(i18n.language);
    // const [emailAlerts, setEmailAlerts] = useState(true);
    // const [investmentUpdates, setInvestmentUpdates] = useState(true);
    // const [monthlySummary, setMonthlySummary] = useState(true);
    const [portfolioValue, setPortfolioValue] = useState(0);
    const [numInvestments, setNumInvestments] = useState(0);
    const [riskLevel] = useState("Medium");
    const [lastInvestmentDate, setLastInvestmentDate] = useState("-");
    const [topOpportunities, setTopOpportunities] = useState([]);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [consentHistory, setConsentHistory] = useState([]);
    const [tab, setTab] = useState(0);
    // const navigate = useNavigate();
    // const [editing, setEditing] = useState(false);
    // const [formData, setFormData] = useState({
    //     firstName: userProfile?.firstName || "",
    //     lastName: userProfile?.lastName || "",
    //     phone: userProfile?.phone || "",
    //     company: userProfile?.company || "",
    //     position: userProfile?.position || "",
    //     address: userProfile?.address || "",
    //     city: userProfile?.city || "",
    //     country: userProfile?.country || "",
    //     postalCode: userProfile?.postalCode || "",
    //     website: userProfile?.website || "",
    //     bio: userProfile?.bio || ""
    // });
    // const [notifications, setNotifications] = useState({
    //     emailAlerts: userProfile?.notifications?.emailAlerts ?? true,
    //     investmentUpdates: userProfile?.notifications?.investmentUpdates ?? true,
    //     monthlySummary: userProfile?.notifications?.monthlySummary ?? true
    // });
    // const [saving, setSaving] = useState(false);
    // const [snackbarOpen, setSnackbarOpen] = useState(false);
    // const [snackbarMessage, setSnackbarMessage] = useState("");
    // const [snackbarSeverity, setSnackbarSeverity] = useState("success");

    // Hook de cumplimiento y seguridad
    const compliance = useUserComplianceData(currentUser?.uid);

    useEffect(() => {
        if (userProfile && typeof userProfile.consentForCommunications === "boolean") {
            setConsent(userProfile.consentForCommunications);
        }
    
        // Obtener inversiones reales y oportunidades
        async function fetchInvestments() {
            if (currentUser) {
                try {
                    const investments = await investmentService.getUserInvestments(currentUser.uid);
                    setNumInvestments(investments.length);
                    setPortfolioValue(investments.reduce((acc, inv) => acc + (inv.amount || 0), 0));
                    if (investments.length > 0) {
                        const sorted = [...investments].sort((a, b) => (b.amount || 0) - (a.amount || 0));
                        setLastInvestmentDate(sorted[0].createdAt);
                        // Obtener detalles de las oportunidades
                        const top = sorted.slice(0, 3);
                        const topWithNames = await Promise.all(top.map(async (inv) => {
                            let name = inv.opportunityTitle;
                            let expectedReturn = inv.expectedReturn;
                            let opportunityId = inv.opportunityId;
                            try {
                                if ((!name || name === "Opportunity not found") && inv.opportunityId) {
                                    const opp = await opportunitiesService.getOpportunityById(inv.opportunityId);
                                    name = opp.title || "Opportunity not found";
                                    expectedReturn = opp.expectedReturn || inv.expectedReturn;
                                    opportunityId = opp.id || inv.opportunityId;
                                }
                            } catch {
                                name = "Opportunity not found";
                            }
                            return {
                                name,
                                opportunityId,
                                invested: inv.amount,
                                expectedReturn: expectedReturn || ""
                            };
                        }));
                        setTopOpportunities(topWithNames);
                    } else {
                        setTopOpportunities([]);
                        setLastInvestmentDate("-");
                    }
                } catch (err) {
                    setTopOpportunities([]);
                }
            }
        }
        fetchInvestments();
    
        // Consent history
        async function fetchConsentHistory() {
            if (currentUser) {
                try {
                    const historyRef = collection(db, "users", currentUser.uid, "consentHistory");
                    const snapshot = await getDocs(historyRef);
                    const history = snapshot.docs.map(doc => doc.data());
                    setConsentHistory(history.sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt)));
                } catch (e) {
                    // console.error("Error fetching consent history:", e);
                    setConsentHistory([]);
                }
            }
        }
        fetchConsentHistory();
    }, [userProfile, currentUser]);

    const handleConsentChange = async (e) => {
        const checked = e.target.checked;
        setLoading(true);
        setConsent(checked);
        // const timestamp = new Date().toISOString();
        try {
            if (currentUser) {
                // TODO(api): Replace direct usersService import with API call
                // await usersService.updateUserProfile(currentUser.uid, {
                //   consentForCommunications: checked
                //   consentForCommunicationsAt: timestamp
                // });
        
                // Agregar al historial de consentimientos
                // await addDoc(collection(db, 'users', currentUser.uid, 'consentHistory'), {
                //   value: checked
                //   changedAt: timestamp
                //   version: '1.0'
                // });
        
                setSnackbar({
                    open: true,
                    message: checked ? "Consentimiento otorgado" : "Consentimiento revocado",
                    severity: "success"
                });
            }
        } catch (error) {
            // console.error("Error updating consent:", error);
            setSnackbar({
                open: true,
                message: "Error al actualizar el consentimiento",
                severity: "error",
            });
        }
        setLoading(false);
    };

    const exportConsentHistoryCSV = () => {
        if (!consentHistory.length) return;
        const header = "Value,Changed At\n";
        const rows = consentHistory.map(h => `${h.value ? "Consented" : "Revoked"},${h.changedAt}`).join("\n");
        const csv = header + rows;
        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "consent_history.csv";
        a.click();
        URL.revokeObjectURL(url);
    };

    // Función para exportar oportunidades a CSV
    const exportOpportunitiesCSV = () => {
        if (!topOpportunities.length) return;
        // Traducciones de los headers
        const header = [
            "Nombre de la Oportunidad",
            "Código de Oportunidad",
            "Cantidad Invertida",
            "Porcentaje Esperado",
            "Retorno Estimado",
        ].join(",") + "\n";
        const rows = topOpportunities.map(op => {
            const retorno = op.invested && op.expectedReturn ? (op.invested * (op.expectedReturn / 100)).toFixed(2) : "";
            return [
                op.name || "",
                op.opportunityId || "",
                op.invested || "",
                op.expectedReturn || "",
                retorno,
            ].join(",");
        }).join("\n");
        const csv = header + rows;
        const blob = new Blob([csv], { type: "text/csv" });
        const fileName = `mis_oportunidades_${i18n.language}.csv`;
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(url);
    };

    // Helper to get last login from Firestore or fallback to Firebase Auth
    const getLastLogin = () => {
        if (userProfile && userProfile.lastLogin) return userProfile.lastLogin;
        if (currentUser && currentUser.metadata && currentUser.metadata.lastSignInTime) return currentUser.metadata.lastSignInTime;
        return null;
    };

    if (!userProfile) return <div className="flex justify-center items-center h-40"><span>Cargando...</span></div>;

    const displayValue = (val, fallback = "No registrado") => val ? val : <span style={{ color: "#888" }}>{fallback}</span>;
    const formatDate = (dateStr) => dateStr ? new Date(dateStr).toLocaleString() : <span style={{ color: "#888" }}>No disponible</span>;

    return (
        <Box sx={{ p: 4, maxWidth: 700, mx: "auto" }}>
            <h2 style={{ fontSize: 28, fontWeight: 600, marginBottom: 24 }}>My Profile</h2>
            <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                aria-label="profile-tabs"
                variant="scrollable"
                scrollButtons="auto"
            >
                <Tab label="Identity & Account" sx={{ minWidth: 120, px: 2 }} />
                <Tab label="Investment Profile" sx={{ minWidth: 120, px: 2 }} />
                <Tab label="Compliance & Security" sx={{ minWidth: 120, px: 2 }} />
                <Tab label="Preferences" sx={{ minWidth: 120, px: 2 }} />
            </Tabs>
            <Divider sx={{ my: 2 }} />
            {tab === 0 && (
                <Card sx={{ mb: 3 }}>
                    <CardContent>
                        <div><strong>Name:</strong> {displayValue(userProfile.firstName || userProfile.lastName ? `${userProfile.firstName || ""} ${userProfile.lastName || ""}`.trim() : null)}</div>
                        <div><strong>Email:</strong> {userProfile.email}</div>
                        <div><strong>Phone:</strong> {displayValue(userProfile.phone)}</div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <strong>KYC Status:</strong> <Chip label={kycData?.status || "not_started"} color={kycData?.status === "approved" ? "success" : "error"} size="small" />
                            {kycData?.status !== "approved" && (
                                <Button variant="outlined" size="small" sx={{ ml: 1 }}>Submit/Update KYC</Button>
                            )}
                        </div>
                        <div><strong>Role:</strong> <Chip label={userProfile.role} variant="outlined" size="small" /></div>
                        <div><strong>Account Created At:</strong> {formatDate(userProfile.createdAt)}</div>
                        <div><strong>{t("profile.lastLogin", "Last Login")}:</strong> {getLastLogin() ? new Date(getLastLogin()).toLocaleString() : <span style={{ color: "#888" }}>{t("profile.notAvailable", "No disponible")}</span>}</div>
                    </CardContent>
                </Card>
            )}
            {tab === 1 && (
                <Card sx={{ mb: 3 }}>
                    <CardContent>
                        <div><strong>Portfolio Value:</strong> €{portfolioValue.toLocaleString()}</div>
                        <div><strong>Number of Investments:</strong> {numInvestments}</div>
                        <div><strong>Preferred Risk Level:</strong> {riskLevel}</div>
                        <div><strong>Last Investment Date:</strong> {formatDate(lastInvestmentDate)}</div>
                        <Divider sx={{ my: 2 }} />
                        <div style={{ fontWeight: 600 }}>Top 3 Invested Opportunities:</div>
                        {topOpportunities.length > 0 ? (
                            <ul style={{ color: "#888", whiteSpace: "nowrap" }}>
                                {topOpportunities.map((op, i) => {
                                    const retorno = op.invested && op.expectedReturn ? (op.invested * (op.expectedReturn / 100)).toFixed(2) : "";
                                    return (
                                        <li key={i}>
                                            {op.name || op}
                                            {op.invested ? ` - €${op.invested}` : ""}
                                            {(op.expectedReturn || retorno) ? ` (${op.expectedReturn ? op.expectedReturn + "%" : ""}${op.expectedReturn && retorno ? ", " : ""}${retorno ? "€" + retorno : ""})` : ""}
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            <div style={{ color: "#888" }}>Aún no tienes inversiones destacadas.</div>
                        )}
                        <Button
                            variant="outlined"
                            size="small"
                            sx={{ mt: 2 }}
                            onClick={exportOpportunitiesCSV}
                            disabled={!topOpportunities.length}
                        >
                            Exportar oportunidades
                        </Button>
                    </CardContent>
                </Card>
            )}
            {tab === 2 && (
                <Card sx={{ mb: 3 }}>
                    <CardContent>
                        {compliance.loading ? (
                            <Typography>Cargando datos de cumplimiento...</Typography>
                        ) : compliance.error ? (
                            <Typography color="error">Error al cargar datos de cumplimiento: {compliance.error}</Typography>
                        ) : (
                            <ComplianceSecuritySection
                                twoFAEnabled={compliance.twoFAEnabled}
                                lastPasswordChange={compliance.lastPasswordChange}
                                loginHistory={compliance.loginHistory}
                                devices={compliance.devices}
                                securityAlerts={compliance.securityAlerts}
                                consentHistory={compliance.consentHistory}
                                dataProcessors={compliance.dataProcessors}
                            />
                        )}
                    </CardContent>
                </Card>
            )}
            {tab === 3 && (
                <Card sx={{ mb: 3 }}>
                    <CardContent>
                        <div><strong>Language Preference:</strong> {i18n.language}</div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}>
                            <strong>Dark Mode:</strong> <Switch checked={darkMode} onChange={e => setDarkMode(e.target.checked)} />
                        </div>
                        <Divider sx={{ my: 2 }} />
                        <div style={{ fontWeight: 600 }}>Notification Preferences:</div>
                        <ul style={{ color: "#888" }}>
                            <li>Email alerts (opportunity updates)</li>
                            <li>Investment status updates</li>
                            <li>Monthly portfolio summary</li>
                        </ul>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 16 }}>
                            <strong>Consent for Communications:</strong>
                            <Switch checked={consent} onChange={handleConsentChange} disabled={loading} />
                        </div>
                        {consentHistory.length > 0 && (
                            <Box sx={{ mt: 3 }}>
                                <div style={{ fontWeight: 600, marginBottom: 8 }}>Consent History</div>
                                <Button variant="outlined" size="small" sx={{ mb: 1 }} onClick={exportConsentHistoryCSV}>
                  Export as CSV
                                </Button>
                                <Box component="table" sx={{ width: "100%", borderCollapse: "collapse", mb: 2 }}>
                                    <Box component="thead">
                                        <Box component="tr" sx={{ background: "#f5f5f5" }}>
                                            <Box component="th" sx={{ p: 1, border: "1px solid #ddd" }}>Value</Box>
                                            <Box component="th" sx={{ p: 1, border: "1px solid #ddd" }}>Changed At</Box>
                                        </Box>
                                    </Box>
                                    <Box component="tbody">
                                        {consentHistory.map((h, i) => (
                                            <Box component="tr" key={i}>
                                                <Box component="td" sx={{ p: 1, border: "1px solid #ddd" }}>{h.value ? "Consented" : "Revoked"}</Box>
                                                <Box component="td" sx={{ p: 1, border: "1px solid #ddd" }}>{new Date(h.changedAt).toLocaleString()}</Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        )}
                    </CardContent>
                </Card>
            )}
            <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default Profile;